import React from 'react';

const StepNotAccomplished = () => {
    return (
        <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="14.5" cy="15" r="14" fill="white" stroke="#70CFD6" />
        </svg>
    )
}

export default StepNotAccomplished;